import { render, staticRenderFns } from "./PermissionsAdminTable.vue?vue&type=template&id=0664fc64"
import script from "./PermissionsAdminTable.vue?vue&type=script&lang=js"
export * from "./PermissionsAdminTable.vue?vue&type=script&lang=js"
import style0 from "./PermissionsAdminTable.vue?vue&type=style&index=0&id=0664fc64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports